export const globalPolyfill = () => {
  var global = global || window;
  if (window) {
    window.global = global;
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-xlsx/dist/polyfills.js
// module id = L8JR
// module chunks = 0